import { node } from "prop-types";
import React, { createContext, useContext, useReducer } from "react";

const ManageMyGivingPageContext = createContext();

const initialState = {
  givingLandingPageEnabled: null,
  landingPageFetchStatus: null,
  network: {
    ID: null,
    city: null,
    state: null,
    iconURL: "",
    name: "",
    shortname: "",
    website: null,
  },
  pageSettings: {
    colorScheme: [],
    colorSchemeIsLight: null,
  },
  funds: [
    // {
    //   ID: null,
    //   description: "",
    //   details: "",
    //   fundColor: "2A6984",
    // },
  ],
  userID: null,
  userGivingData: {},
  userGivingDataStatus: null,
  showACHModal: false,
  showCCModal: false,
  recurringGiftUpdateComplete: false, // used to trigger a refetch of MMG page data
  paymentMethodTypes: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case "setState": {
      return {
        ...state,
        ...action.payload,
      };
    }

    case "setLandingPageFetchStatus": {
      return {
        ...state,
        landingPageFetchStatus: action.payload,
      };
    }

    case "setUserGivingDataStatus": {
      return {
        ...state,
        userGivingDataStatus: action.payload,
      };
    }

    case "setUserGivingData": {
      return {
        ...state,
        userGivingData: {
          ...action.payload,
        },
      };
    }

    case "setColorSchemeIsLight": {
      return {
        ...state,
        pageSettings: {
          ...state.pageSettings,
          colorSchemeIsLight: action.payload,
        },
      };
    }

    case "setPaymentMethodTypes": {
      return {
        ...state,
        paymentMethodTypes: action.payload,
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

ManageMyGivingPageProvider.propTypes = {
  children: node,
};

function ManageMyGivingPageProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setState = (payload) => dispatch({ type: "setState", payload });

  return (
    <ManageMyGivingPageContext.Provider value={{ state, dispatch, setState }}>
      {children}
    </ManageMyGivingPageContext.Provider>
  );
}

function useManageMyGivingPage() {
  const context = useContext(ManageMyGivingPageContext);
  if (context === undefined) {
    throw new Error(
      `useManageMyGivingPage must be used within a ManageMyGivingPageProvider`
    );
  }
  return context;
}

export {
  ManageMyGivingPageContext,
  ManageMyGivingPageProvider,
  useManageMyGivingPage,
  initialState,
};
